import { SERVICE_WORKER_PATH } from '@md/shared';

/**
 * Enregistrement du service worker (phase 5).
 *
 * Il rend le jeu **installable** (avec le manifeste) et lui donne un secours
 * hors ligne. L'enregistrement est volontairement tolérant : navigateur sans
 * `serviceWorker`, contexte non sécurisé (HTTP sur une IP de LAN), ou refus de
 * l'utilisateur — rien ne doit empêcher de jouer.
 *
 * L'état est publié sur `<html data-pwa="…">` : c'est ce que les tests de bout
 * en bout observent, sans avoir à interroger l'API du navigateur.
 */
export type PwaState = 'unsupported' | 'registering' | 'ready' | 'failed';

function publish(state: PwaState): void {
  document.documentElement.dataset.pwa = state;
}

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    publish('unsupported');
    return;
  }
  publish('registering');
  navigator.serviceWorker
    .register(SERVICE_WORKER_PATH, { scope: '/' })
    .then(() => {
      publish('ready');
    })
    .catch(() => {
      // Contexte non sécurisé, quota, ou fichier absent : le jeu fonctionne
      // exactement pareil, il n'est simplement pas installable.
      publish('failed');
    });
}
